import { gql } from '@apollo/client';

export const MEMBER_TAG_CREATE = gql`
    mutation MemberTagCreate($name: String!, $category: String) {
        memberTagCreate(name: $name, category: $category) {
            tag {
                id
                name
                slug
                category
            }
        }
    }
`;

export const MEMBER_TAGS_UPDATE = gql`
    mutation MemberTagsUpdate($tagIds: [ID]!, $member: ID) {
        memberTagsUpdate(tagIds: $tagIds, member: $member) {
            user {
                id
                tags {
                    edges {
                        node {
                            id
                            name
                        }
                    }
                }
            }
        }
    }
`;
